module.exports = __webpack_public_path__ + "img/login4.0889e9fc.jpg";